/**
 * Truncates text to a word limit while preserving paragraph breaks.
 * Returns the truncated text with '...' appended if truncated.
 */
export const truncatePreservingNewlines = (text, limit) => {
  if (!text) return '';
  if (!limit) return String(text);
  let wordsUsed = 0;
  let truncated = false;
  const out = [];
  const rawParagraphs = String(text).split(/\n+/);
  for (let i = 0; i < rawParagraphs.length; i++) {
    const para = rawParagraphs[i];
    const tokens = para.trim().length ? para.trim().split(/\s+/) : [];
    const chosen = [];
    for (const tok of tokens) {
      if (wordsUsed >= limit) { truncated = true; break; }
      chosen.push(tok);
      wordsUsed++;
    }
    out.push(chosen.join(' '));
    if (wordsUsed >= limit) break;
  }
  let result = out.join('\n\n');
  if (truncated) result = result + '...';
  return result;
};

/**
 * Formats a Firestore Timestamp to a da-DK date string (dd.mm.yy).
 * Accepts Firestore timestamps (with .toDate()), JS Date objects, or null.
 */
export const formatDate = (date) => {
  if (!date) return '';
  const jsDate = date.toDate ? date.toDate() : date;
  return new Date(jsDate).toLocaleDateString('da-DK', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};
